import { auth } from '@/shared/lib';
import { useLoginByBanner } from './useLoginByBanner';
import closeIcon from './assets/close-icon-banner.svg';
import './styles.scss';

/**
 * Banner telling the user their session was opened from another portal. Renders only while state.isShowLoginByBanner is set, naming Admin or Sales from auth.isLoginThroughAdmin, and dismisses through the onClickClose callback of useLoginByBanner.
 *
 * @returns The rendered banner element, or false when hidden.
 */
const LoginByBanner = () => {
  const { state, onClickClose } = useLoginByBanner();

  return (
    state.isShowLoginByBanner && (
      <div className="login-by-banner-container">
        <div className="empty-div" />

        <div className="login-by-banner">
          <div className="content">
            You’re logged in through {auth.isLoginThroughAdmin() ? 'Admin' : 'Sales'} portal
          </div>
          <button type="button" aria-label="Close" className="close-btn" onClick={onClickClose}>
            <img src={closeIcon} alt="Close icon" />
          </button>
        </div>
      </div>
    )
  );
};

export default LoginByBanner;
